import React from "react";

export const SourcingIcon = ({ fill }: { fill?: string }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_2925_104298"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2925_104298)">
        <path
          d="M3 17V15.5H4.5V3H12V4H15.5V15.5H17V17H14V5.5H12V17H3ZM8.99563 10.75C9.20688 10.75 9.38542 10.6785 9.53125 10.5356C9.67708 10.3927 9.75 10.2156 9.75 10.0044C9.75 9.79312 9.67854 9.61458 9.53562 9.46875C9.39271 9.32292 9.21562 9.25 9.00437 9.25C8.79312 9.25 8.61458 9.32146 8.46875 9.46438C8.32292 9.60729 8.25 9.78438 8.25 9.99563C8.25 10.2069 8.32146 10.3854 8.46438 10.5312C8.60729 10.6771 8.78438 10.75 8.99563 10.75ZM6 15.5H10.5V4.5H6V15.5Z"
          fill={fill || "#1f1d1b"}
        />
      </g>
    </svg>
  );
};
